import axios from 'axios'
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../../store/serviceUrls";

export const getPlanDetailsRepo = (params) => {
    return axios({
        method: 'GET',
        url: Urls.GET_PLAN,
        params: params
    })

}

export const getCmsProductGroupListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_PRODUCT_PLAN_API + id : Urls.GET_CMS_PRODUCT_PLAN_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}

export const postCmsProductGroupRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_PRODUCT_PLAN_API + id,
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCT_PLAN_API,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getCmsProductGroupFeatureListRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_PRODUCT_PLAN_FEATURE_API,
        params: data
    })
}

//SPG REPOS
export const getCmsProductSpgTypeRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_SPG_TYPE_LIST_API,
        params: data
    })
}

export const getCmsMappedEntityTypeRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_MAPPED_ENTITY_LIST_API,
        params: data
    })
}

export const getCmsMappedEntityRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_MAPPED_ENTITY_API,
        params: data
    })
}

export const getCmsLearnEntityRepo = (data) => {
    return axios({
        baseURL: ServiceUrls.LEARN_SERVICE + process.env.REACT_APP_SUB_DOMAIN_NAME,
        method: 'GET',
        url: Urls.GET_LEARN_MAPPED_ENTITY_API,
        params: data
    })
}

export const getCmsAutoAccessRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_AUTO_ACCESS_API,
        params: data
    })
}

export const getCmsSpgInterestRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_SPG_INTEREST_API,
        params: data
    })
}

export const getCmsAdditionalMappingFieldRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_ADDITIONAL_MAPPING_FIELDS,
        params: data
    })
}

export const getCmsEntityValidateRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_ENTITY_VALIDATE_API,
        params: data
    })
}

export const getCmsSpgLevelsRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_SPG_LEVELS_API,
        params: data
    })
}

export const getCmsProductMappedEntityRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_PRODUCT_MAPPED_ENTITY_API,
        params: data
    })
}

export const postCmsProductGroupFeatureRepo = (data) => {
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCT_PLAN_FEATURE_API,
        data: data,
    })
}

export const getCmsFeatureListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_PRODUCT_FEATURE_API + id : Urls.GET_CMS_PRODUCT_FEATURE_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}

export const postCmsFeatureRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_PRODUCT_FEATURE_API + id,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCT_FEATURE_API,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getCmsFeatureGroupRepo = () => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_FEATURE_GROUPS_LIST_API,
    })
}

export const getCmsProductListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_PRODUCTS_API + id : Urls.GET_CMS_PRODUCTS_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}
export const postCmsProductRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_PRODUCTS_API + id,
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCTS_API,
        data: data,
    })
}

export const getCmsProductTypeListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_PRODUCT_TYPE_API + id : Urls.GET_CMS_PRODUCT_TYPE_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}
export const postCmsProductTypeRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_PRODUCT_TYPE_API + id,
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCT_TYPE_API,
        data: data,
    })
}

export const getCmsProuductMappedEntityRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_PRODUCT_MAPPED_ENTITY,
        params: data
    })
}
export const getCmsProuductSellebleTypeRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_PRODUCT_SELLEBLE_TYPE,
        params: data
    })
}

export const getCmsProuductMappedEntityCheckRepo = (data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_PRODUCT_MAPPED_ENTITY_CHECK,
        params: data
    })
}

export const getCmsMapProductFeatureListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_MAP_PRODUCT_FEATURE_API + id : Urls.GET_CMS_MAP_PRODUCT_FEATURE_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}
export const postCmsMapProductFeatureRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_MAP_PRODUCT_FEATURE_API + id,
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_MAP_PRODUCT_FEATURE_API,
        data: data,
    })
}

export const getCmsFeatureSynonymRepo = (id, data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_FEATURE_SYNONYMS_API + id,
        params: data
    })
}

export const postCmsFeatureSynonymRepo = (id, data) => {
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_FEATURE_SYNONYMS_API + id,
        data: data
    })
}

export const getCmsLandingPageListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_PRODUCT_LANDING_API + id + '/' : Urls.GET_CMS_PRODUCT_LANDING_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}

export const postCmsLandingPageRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_PRODUCT_LANDING_API + id + '/',
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_PRODUCT_LANDING_API,
        data: data,
    })
}

export const getCmsLandingPageFaqListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_LANDING_PAGE_FAQ_API + id + '/' : Urls.GET_CMS_LANDING_PAGE_FAQ_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}
export const postCmsLandingPageFaqRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_LANDING_PAGE_FAQ_API + id + '/',
            data: data,
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_LANDING_PAGE_FAQ_API,
        data: data,
    })
}

export const getCmsLandingPageSpgListRepo = (id, data) => {
    let url = id ? Urls.GET_SPG_LANDING_API + id + '/' : Urls.GET_SPG_LANDING_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}
export const postCmsLandingPageSpgRepo = (data, id) => {
    return axios({
        method: 'POST',
        url: Urls.GET_SPG_LANDING_API + id + '/',
        data: data,
    })
}

export const getCmsLandingPageBannerRepo = (id, data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_LANDING_PAGE_BANNER + id + '/',
    })
}

export const getCmsLandingPageBannerListRepo = (id, data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_LANDING_PAGE_BANNER_LIST,
    })
}

export const postCmsLandingPageBannerRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.GET_CMS_LANDING_PAGE_BANNER + id + '/',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    return axios({
        method: 'POST',
        url: Urls.GET_CMS_LANDING_PAGE_BANNER_LIST,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getCmsUserProductListRepo = (id, data) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_USER_SELLABLE_PRODUCT_API,
        params: data
    })
}

export const putCmsPaymentDetailUpdateRepo = (data) => {
    return axios({
        method: 'PUT',
        url: Urls.PUT_CMS_PAYMENT_DEATAILS_UPDATE_API,
        data: data,
    })
}


export const getCmsUserProductDetailRepo = (id) => {
    return axios({
        method: 'GET',
        url: Urls.GET_CMS_USER_SELLABLE_PRODUCT_DETAIL_API + id,
    })
}

export const editCmsUserProductDetailRepo = (data, id) => {
    return axios({
        method: 'PUT',
        url: Urls.GET_CMS_USER_SELLABLE_PRODUCT_DETAIL_API + id,
        data: data
    })
}

export const postCmsUserProductSpgRepo = (data) => {
    return axios({
        method: 'POST',
        url: Urls.POST_CMS_USER_SELLABLE_PRODUCT_SPG_API,
        data: data,
    })
}

export const getHomePagePlansRepo = (user_id) => {
    return axios({
        method: 'GET',
        url: Urls.GET_HOMEPAGE_PLANS,
        params: { "user_id": user_id }
    })
}

export const getFeatureGroupsListRepo = (id, data) => {
    let url = id ? Urls.GET_CMS_FEATURE_GROUPS_LIST_API + id : Urls.GET_CMS_FEATURE_GROUPS_LIST_API
    return axios({
        method: 'GET',
        url: url,
        params: data
    })
}

export const postCmsFeatureGroupsRepo = (data, id) => {
    if (id) {
        return axios({
            method: 'PUT',
            url: Urls.PUT_CMS_FEATURE_GROUPS_API + id,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    return axios({
        method: 'POST',
        url: Urls.POST_CMS_FEATURE_GROUPS_API,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getMapProductsDataRepo = (id) => {
    return axios({
        method: 'GET',
        url: Urls.GET_MAP_PRODUCT_API + id
    })
}

export const putProductSpgMappingRepo = (data, id) => {
    return axios({
        method: 'PUT',
        url: Urls.PUT_PRODUCT_SPG_MAPPING_API,
        data: data
    })
}
